import {ForwardingBatchItemType} from "@twigsby/client-data/lib/Types/ForwardingBatchTypes";
import {MailFile} from "@twigsby/client-data/lib/Types/MailFileTypes";
import {
    Badge,
    ColourOutline,
    FlexGap,
    ItemRow,
    ItemRowSize,
    Pill,
    PillSize,
    Placement,
    StackVertical,
    useLayout,
    useTranslation
} from "@twigsby/frontend-framework";
import React, {memo} from 'react';
import {MailItemNoThumbnail, MailItemThumbnail, MailPartTypeEnum} from "../Mail/MailItemThumbnails";

export const ForwardingBatchContents = (props: MailFile) => {
    return (
        props.userFileThumbnails && props.userFileThumbnails.length > 0 ? (
            <div className={props.userFileThumbnails.length === 1 ? '' : `thumbnail-stack`}>
                {props.userFileThumbnails.map((file, index) =>
                    <MailItemThumbnail {...file} key={`forwardingBatchContentsThumb${file.fileName}${index}`} />
                )}
            </div>
        ) : (
            <MailItemNoThumbnail mailType={MailPartTypeEnum['Mail-Envelopes']} />
        )
    )
}

const ForwardingBatchItemMinimal = memo((props: ForwardingBatchItemType) => {
    const { t } = useTranslation();
    const { isLarge, isXXL } = useLayout();
    const statusColour = props.statusDescription === 'Forwarded' ? ColourOutline.Success : props.statusDescription === 'Pending' ? ColourOutline.Warning : ColourOutline.Alert;

    return (
        <ItemRow
            size={ItemRowSize.Large}
            highlighted={statusColour === ColourOutline.Alert}
            muted={statusColour !== ColourOutline.Alert}
            extraProps={{
                'draggable': false,
            }}
            actionLink={{ url: `/mail/forwarding-batches/${props.batchId}`}}
        >
            <div style={{ position: 'relative'}}>
                {props.files.map((file, index) =>
                    <ForwardingBatchContents {...file} />
                )}

                <Badge placement={Placement.BottomRight} value={props.itemsInBatch} />
            </div>

            <div className='flex-row flex-gap-sm mail-item-reference'>
                <StackVertical gap={FlexGap.ExtraSmall}>
                    <strong className='mail-item-tracking-id'>
                        {props.batchIdNo}
                    </strong>
                    <Pill
                        content={t("status.dynamicType", {action: props.statusDescription})}
                        colour={statusColour}
                        size={PillSize.Small}
                    />
                </StackVertical>
            </div>

            {isLarge && (
                <div>
                    <StackVertical gap={FlexGap.ExtraSmall}>
                        <small>Address</small>
                        <span className={'text-overflow'}>{props.forwardingAddress.formatted}</span>
                    </StackVertical>
                </div>
            )}

            {isXXL && (
                <div>
                    <StackVertical gap={FlexGap.ExtraSmall}>
                        <small>Postage</small>
                        <span className={'text-overflow'}>{props.postageOption}</span>
                    </StackVertical>
                </div>
            )}
        </ItemRow>
    );
});

export default ForwardingBatchItemMinimal;
